import { APP_BUNDLES, GET_PRACTICE_TEST } from '../../app_constant';
import { BUNDLE_ARTICLE_COUNTS } from '../../content';
import { GET_LOCAL_QUESTIONS, GET_FLASHCARDS, GET_GLOSSARY, GET_ACRONYMS } from '../api/content';

/**
 * Returns an array of exam details for all available exams.
 * Each object contains:
 *   - key: exam key (e.g., 'cisa')
 *   - name: exam name/title (e.g., 'CISA')
 *   - vendor / displayName: two-line chip vocabulary (same as mobile onboarding);
 *     brands without them fall back to name
 *   - numQuestions: number of questions for the exam
 *   - numPracticeTests: number of full practice exams
 *   - numFlashcards: number of flashcards for the exam
 *   - numArticles: number of articles for the exam
 *   - numGlossary: number of glossary terms for the exam
 *   - numAcronyms: number of acronyms for the exam
 */
export function getExamDetails() {
  return APP_BUNDLES.map((bundle) => {
    const key = bundle.key;
    const name = bundle.title;
    const description = bundle.description;
    const numQuestions = GET_LOCAL_QUESTIONS(key)?.length || 0;
    // GET_PRACTICE_TEST falls back to a default exam's test list for keys
    // missing from PRACTICE_TESTS, so this never reads 0 for an unmapped key —
    // every APP_BUNDLES key must be mapped or another exam's count shows here.
    const numPracticeTests = GET_PRACTICE_TEST(key)?.length || 0;
    const numFlashcards = GET_FLASHCARDS(key)?.length || 0;
    const numArticles = BUNDLE_ARTICLE_COUNTS[key] || 0;
    const numGlossary = GET_GLOSSARY(key)?.length || 0;
    const numAcronyms = GET_ACRONYMS(key)?.length || 0;

    return {
      key,
      name,
      description,
      vendor: bundle.vendor,
      displayName: bundle.display_name,
      numQuestions,
      numPracticeTests,
      numFlashcards,
      numArticles,
      numGlossary,
      numAcronyms,
    };
  });
}